// Store reference utility to access Redux store outside of React components
import { store } from "../../Redux/Store/store";

export const getStore = () => {
  return store;
};
